import { closeModal, openCreditBoxModal } from './active_modal';
import { detachCustomer } from './customer';
import { destroyPaymentMethods, getCustomerPaymentMethods } from './payment_methods';
import { setComputedCart } from './computed_cart';
import { setLoggedOut, setLoggedIn } from './is_logged_in';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';
import { activeStepCreate, activeStepCheckout } from './active_enroll_step';
import { setCustomer } from './customer';
import { fireLoginError, delayedClearLoginError, clearLoginError } from './login_error';
import { clearEnrollShippingSuccess} from './enroll_shipping_success';
import { clearEnrollPaymentSuccess } from './enroll_payment_success';
import { clearCreditAcceptState } from './credit_accept_state';
import { setCreditViewDefault } from './credit_view';
import { parseLocationPath } from './path'
import { constructActiveFilter } from './active_filter'
import { initializeActiveProduct } from './active_product';
import { navigateMoreBooks } from './maps';
import { fireUpgradeStatus, clearUpgradeStatus } from './upgrade_status';

import request from 'superagent';

export function navigate(evt, updateActiveProduct = true) {
  return (dispatch, getState) => {
    let sPathname = evt.currentTarget.pathname,
        { activeFilterResult, activeFilter, isLoggedIn, customer, upgradeStatus, path } = getState();

    if(updateActiveProduct)
        dispatch([
          parseLocationPath(sPathname),
          constructActiveFilter(),
          initializeActiveProduct(),
          navigateMoreBooks(),
          closeModal()
        ]);
    else
        dispatch([
            parseLocationPath(sPathname),
            navigateMoreBooks()
        ]);

    if (!window || !window.history.pushState) return;
    // push state to Window History object and reset scroll
    evt.preventDefault();
    window.history.pushState(null, null, sPathname);
    window.scrollTo(0,0);

    //push 'page' to GA
    window.dataLayer.push({event: 'pageview', url: window.location.hostname + sPathname, logged_in: isLoggedIn});
  }
}

export function deleteCookie(name) {
  if (typeof document !== 'undefined') {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

export function getMember(oFormData){
	return (dispatch, getState) => {
    request
      .get('/svc/customer/')
      .query({'email': oFormData['email']})
      .query({'password': oFormData['password']})
      .end((err, res) => {
        if (err) {
          let sError;
          if (res.statusText === 'Incorrect password.') {
            sError = `This email address is already associated with an account.
            Please enter the correct password or`;
          } else {
            sError = `OOPS...
            The information you entered did not match any account in our files.
            Remember, passwords are case-sensitive.
            Please try again, click 'forgot your password', or enroll as a new customer.`;
          }
          if (res.status === 403) {
            sError = `Your account has been canceled; only active members can log in.
              Please contact Customer Service to reactivate your account.`;
          }
          return dispatch([
          	setLoggedOut(),
            fireLoginError(sError),
            delayedClearLoginError()
          ]);
        }
        if(getState().store.type === "Neglite" || (res.body.status === 'Cancelled')){
          if ((res.body.status === 'Pending' && new Date( res.body.accepted_terms_at) > new Date() - (2 * 24 * 60 * 60 * 1000)) || (res.body.status === 'Cancelled'))
            dispatch([ activeStepCheckout(), clearUpgradeStatus() ]);
          else if( res.body.status === 'Pending' && new Date( res.body.accepted_terms_at) <= new Date() - (2 * 24 * 60 * 60 * 1000) )
            dispatch( fireUpgradeStatus() );
        }

        dispatch([
        	setLoggedIn(),
          clearCreditAcceptState(),
          setCreditViewDefault(),
          getCustomerPaymentMethods(),
          clearEnrollPaymentSuccess(),
          clearEnrollShippingSuccess(),
        	setCustomer(res.body),
        	setComputedCart(res.body, getState().computedCart, []),
        	clearLoginError()
        ]);

        // check for store type
        const sStoreType = getState().store.type || '';
        // check for member type
        const sFulfillmentType    = getState().customer.fulfillment_type || '';
        // check for new credits available
        const bCreditsAvailable = getState().customer.current_cycle.active || '';
        if (sStoreType === 'Neglite' && bCreditsAvailable && sFulfillmentType === 'Negative')
          return dispatch( openCreditBoxModal() );
        else
          return dispatch( closeModal() );
      });
  }
}

export function getAccount(oFormData) {
  return (dispatch, getState) => {
    request
      .get('/svc/customer')
      .query({'sap_account_number': oFormData['sap_account_number']})
      .query({'zip': oFormData['zip']})
      .query({'email': oFormData['email']})
      .query({'password': oFormData['password']})
      .end((err, res) => {
        if (err || res.statusCode !== 200 ) {
          // console.log('get account:', err);
          let sError = `OOPS...
            The information you entered did not match any account in our files.
            Remember, passwords are case-sensitive.
            Please try again.`;
          if (res.status === 403) {
            sError = `Your account has been canceled; only active members can log in.
              Please contact Customer Service to reactivate your account.`;
          }
          return dispatch([
            setLoggedOut(),
            fireLoginError(sError),
            delayedClearLoginError()
          ]);
        } else {
          dispatch([
            setCustomer(res.body),
            clearLoginError(),
            setComputedCart(res.body, getState().computedCart, [])
          ]);

          // check for member type
          const sFulfillmentType    = getState().customer.fulfillment_type || '';
          // check for new credits available
          const bCreditsAvailable = getState().customer.current_cycle.active || '';

          if (bCreditsAvailable && sFulfillmentType === 'Negative')
            return dispatch( openCreditBoxModal());
          else
            return dispatch( closeModal() );
        }
      });
  }
}

export function requestPasswordReset(sEmail){
  return dispatch => {
    request
        .put('/svc/customer/requestPasswordReset')
        .query({'email': sEmail})
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err || res.statusCode !== 200 ) {
            console.warn(err);
            return dispatch([
              setFeedback('Could not submit your password reset request.'),
              delayedClearFeedback()
            ]);
          }
          return dispatch([
            setFeedback('Check your email for a link to reset your password'),
            delayedClearFeedback()
          ]);
        });
  }
}



// WEBPACK FOOTER //
// ./src/modules/high_level_actions.js